<template>
  <div class="create-order relative">
    <div class="order-content relative flex flex-col">
      <div class="">
        <div
          v-if="orderId"
          style="
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
            align-items: center;
          "
        >
          <!-- <div style="font-size: 16px; margin-left: 5px; font-weight: bold">
        订单类型
      </div> -->
          <div v-if="!orderId" class="ordertype-box">
            <div
              @click="createType = 2"
              :class="createType === 2 ? 'select' : ''"
            >
              预订单
            </div>
            <div
              v-if="!simpleAdd"
              @click="createType = 3"
              :class="createType === 3 ? 'select' : ''"
            >
              散客单
            </div>
            <div
              @click="createType = 4"
              :class="createType === 4 ? 'select' : ''"
              v-if="visibleYuLiu && !simpleAdd"
            >
              预留单
            </div>
            <div
              @click="createType = 1"
              :class="createType === 1 ? 'select' : ''"
              v-if="visibleYuYue && !simpleAdd"
            >
              预约单
            </div>
          </div>
          <div v-else class="ordertype-box">
            <div v-if="createType === 2" class="select">预订单</div>
            <div v-if="createType === 3" class="select">散客单</div>
            <div v-if="createType === 4 && visibleYuLiu" class="select">
              预留单
            </div>
            <div v-if="createType === 1 && visibleYuYue" class="select">
              预约单
            </div>
          </div>
          <el-icon @click="close" style="cursor: pointer"><Close /></el-icon>
        </div>
        <div
          class="mt-2 pb-4"
          style="border: 1px solid #e6e6e6; border-radius: 4px 4px 0px 0px"
        >
          <div
            class="h-[48px] flex items-center rounded-md text-lg font-medium px-4"
            style="
              background: linear-gradient(180deg, #fafafa 0%, #f0f0f0 100%);
            "
          >
            <div
              class="flex items-center justify-between w-full"
              style="line-height: 28px"
            >
              <div class="flex items-center">
                <!-- 就餐日期 -->
                <img
                  class="flex"
                  style="width: 23px; height: 22px"
                  src="@/assets/rili.png"
                  alt=""
                />
                <span class="ml-2"
                  >{{ props.mealDate.slice(5, props.mealDate.length) }}
                </span>
                <span class="ml-2 mr-6">{{
                  props.calendar.solar2lunar(
                    props.mealDate.split("-")[0],
                    props.mealDate.split("-")[1],
                    props.mealDate.split("-")[2]
                  ).ncWeek +
                  "  (" +
                  (props.calendar.solar2lunar(
                    props.mealDate.split("-")[0],
                    props.mealDate.split("-")[1],
                    props.mealDate.split("-")[2]
                  ).IMonthCn +
                    props.calendar.solar2lunar(
                      props.mealDate.split("-")[0],
                      props.mealDate.split("-")[1],
                      props.mealDate.split("-")[2]
                    ).IDayCn) +
                  ")"
                }}</span>
              </div>
              <div
                class="flex justify-center items-center flex-1"
                v-if="props.mealtypes.length"
              >
                <img
                  class="w-8 h-8 mr-2"
                  :src="mealTypeImageList[mealtype.segmenttype - 1]"
                  alt=""
                />{{
                  props.mealtypes.filter(
                    (p) => p.segmenttype === mealtype.segmenttype
                  )[0].segmentname
                }}
              </div>
            </div>
          </div>
          <div class="hall-list mt-4 px-2" v-if="desklist.length">
            <div
              class="relative"
              v-for="desk in desklist"
              :key="desk.desk.deskid"
            >
              <div
                class="hall"
                :style="{
                  '--sanke-back-color': colors.sankeBackColor,
                  '--sanke-front-color': colors.sankeFrontColor,
                  '--yvding-back-color': colors.yvdingBackColor,
                  '--ding-back-fotter': colors.dingBackFotterColor,
                  '--select-back-color': colors.selectBackColor,
                }"
              >
                <div class="select-deskbox">
                  <div class="desk-name py-2.5">
                    {{ desk.desk.deskname }}
                  </div>
                </div>
              </div>
              <img
                @click="deleteDeskList(desk)"
                class="absolute top-1 right-1 cursor-pointer"
                style="width: 16px; height: 16px"
                src="@/assets/close.png"
                alt=""
              />
            </div>
          </div>
          <div
            v-else
            class="flex items-center pl-2 min-h-[55px] pt-[18px]"
            style="color: #ff9f2a"
          >
            <InfoFilled
              style="width: 16px; height: 16px"
              class="mr-1"
            />未选择餐位，只能创建预约单！
          </div>
        </div>
        <div class="r-info mt-2 flex items-center">
          <div class="r-label">就餐人数</div>
          <el-input-number
            class="flex-1"
            v-model="orderInfo.number"
            :min="1"
            :max="100"
            :controls="false"
          />
        </div>
        <div
          class="flex items-center flex-wrap"
          style="background: linear-gradient(180deg, #fafafa 0%, #f0f0f0 100%)"
        >
          <div
            style="width: 9.8%"
            :style="
              'background:' + (orderInfo.number === i + 1 ? '#3F3CFF' : 'none')
            "
            :class="{ 'bg-blue-500': orderInfo.number === i + 1 }"
            class="flex justify-center items-center w-12 h-8 cursor-pointer border-l border-b border-gray-200 text-black text-opacity-60"
            v-for="(item, i) in new Array(10).fill(0)"
            :key="i"
            @click="orderInfo.number = i + 1"
          >
            <div :class="{ 'text-white': orderInfo.number === i + 1 }">
              {{ i + 1 }}
            </div>
          </div>
        </div>
        <div class="mt-6 w-full" v-show="!isCreate" v-if="props.id === '2'">
          <el-input
            style="background: #f5f5f5"
            class="textarea w-full"
            v-model="textarea"
            maxlength="100"
            :rows="3"
            resize="none"
            placeholder="备注"
            show-word-limit
            type="textarea"
          />
        </div>
        <div
          class="mt-2 w-full flex justify-between items-center gap-1"
          v-show="!isCreate"
          v-if="props.id === '2'"
        >
          <el-button class="conston-btn" type="danger" @click="creatOrder"
            ><img
              style="width: 16px; height: 16px"
              src="@/assets/order/add.png"
              class="mr-1"
            />{{ desklist.length ? "创建订单" : "创建预约单" }}</el-button
          >
          <el-button
            v-show="desklist.length"
            :loading="loading1"
            class="btn-item font-normal !ml-0 !px-2.5"
            type="danger"
            @click="saveOrderData1(3)"
            ><img
              style="width: 16px; height: 16px"
              src="@/assets/order/san.png"
              class="mr-1"
            />散客入座</el-button
          >
          <el-popover
            ref="givePopover"
            placement="top"
            title="预留给"
            :width="500"
            trigger="click"
          >
            <div class="flex flex-wrap my-4">
              <div
                class="flex justify-center items-center w-[118px] cursor-pointer h-10"
                :class="{ 'text-white': receiverOrderId === item.id }"
                :style="
                  'background:' +
                  (receiverOrderId === item.id ? '#3F3CFF' : 'none')
                "
                v-for="(item, i) in receiverList"
                :key="i"
                @click="selectPeople(item)"
              >
                {{ item.name }}
              </div>
            </div>
            <div
              class="flex justify-center h-12 items-center"
              style="background: #f5f5f5"
            >
              <el-button plain @click="giveClose">取消</el-button>
              <el-button
                type="danger"
                btn-item
                :loading="loading2"
                @click="saveOrderData1(4)"
                >确认预留</el-button
              >
            </div>
            <template #reference>
              <el-button
                v-show="desklist.length"
                class="font-normal btn-item !ml-0 !px-2.5"
                type="danger"
                @click="toGive"
                ><img
                  style="width: 16px; height: 16px"
                  src="@/assets/order/liu.png"
                  class="mr-1"
                />预留给</el-button
              >
            </template>
          </el-popover>
          <el-button
            class="btn-item font-normal !ml-0 !px-2.5"
            type="danger"
            @click="close"
          >
            <img src="@/assets/order/close.png" class="mr-1" />关闭</el-button
          >
        </div>
      </div>
    </div>
    <div v-if="isCreate || props.id !== '2'">
      <div class="inputbox">
        <div class="gridbox">
          <!-- <el-row class="r-info">
          <div :span="8" class="r-label">预订日期</div>
          <div class="c-info" :span="16">
            <el-date-picker
              style="width: 120px"
              v-model="banquetDate"
              type="date"
              :clearable="false"
              @change="changeDate"
              placeholder="就餐日期"
            />
          </div>
        </el-row>
        <el-row
          class="r-info"
          v-if="continuousBookingFlag === 1 && [2].includes(createType)"
        >
          <div :span="8" class="r-label">结束日期</div>
          <div class="c-info" :span="16">
            <el-date-picker
              style="width: 120px"
              v-model="mealDateEnd"
              type="date"
              :clearable="false"
              placeholder="结束日期"
            />
          </div>
        </el-row> -->
          <!-- <el-row class="r-info" style="align-items: center">
          <div :span="8" class="r-label">餐段类型</div>
          <div class="c-info" :span="16">
            <el-tag
              @click="
                changeMealDate(banquetDate + ' ' + meal.endtime < nowTime, meal)
              "
              style="margin-right: 2px; cursor: pointer"
              :type="
                mealtype.segmenttype === meal.segmenttype
                  ? ''
                  : banquetDate + ' ' + meal.endtime < nowTime
                  ? 'danger'
                  : 'info'
              "
              v-for="meal in mealtypes"
              :key="meal.segmenttype"
              >{{ meal.segmentname }}</el-tag
            >
          </div>
        </el-row> -->
          <!-- <el-row class="r-info">
          <div :span="8" class="r-label"s>用餐人数</div>
          <div class="c-info" :span="16">
            <el-input style="width: 120px" v-model="orderInfo.number">
              <template #append> 人 </template>
            </el-input>
          </div>
        </el-row> -->
          <div class="mt-3 mb-3" style="color: #999999">必填项</div>
          <div v-if="memberinfo.cyclicClassName" class="memberbox">
            <div style="display: flex">
              <p>
                <span class="membertitle">会员级别：</span
                >{{ memberinfo.cyclicClassName }}，人均{{
                  memberinfo.consumptionPerPerson
                }}元
              </p>
            </div>
            <div style="display: flex">
              <P
                ><span class="membertitle">订单情况：</span
                >{{ memberinfo.countOrder }}单，<span style="color: #ec5f5f"
                  >撤{{ memberinfo.countOrderCanceled }}单</span
                ></P
              >
            </div>
            <div class="flex justify-between">
              <p>
                <span class="membertitle">上次消费：</span
                >{{ memberinfo.orderDayLast }}（{{ memberinfo.orderDeskLast }}）
              </p>
              <p class="ml-2">
                <span>经理：</span>{{ memberinfo.resourceAssignManagerName }}
              </p>
            </div>
          </div>
          <div class="gridbox">
            <el-row class="r-info">
              <div class="r-label w-8">电话</div>
              <div class="c-info">
                <el-input
                  v-model="orderInfo.phone"
                  @blur="onPhoneWeChatBlur"
                  @keyup="onPhoneKeyup"
                ></el-input>
              </div>
            </el-row>
            <el-row class="r-info">
              <div :span="2" class="r-label">微信</div>
              <div class="c-info" :span="22">
                <el-input
                  v-model="orderInfo.wechatid"
                  @blur="onPhoneWeChatBlur"
                ></el-input>
              </div>
            </el-row>
            <div class="flex gap-1">
              <el-row class="r-info">
                <div class="r-label">姓名</div>
                <div
                  style="display: flex; justify-content: end"
                  class="c-info flex-1"
                >
                  <el-input v-model="orderInfo.name"></el-input>
                </div>
              </el-row>
              <el-row class="r-info w-1/2">
                <div class="sexbox" style="color: #666666">
                  <div
                    @click="orderInfo.sex = 1"
                    :class="orderInfo.sex === 1 ? 'select' : ''"
                    class="sex"
                  >
                    <img src="@/assets/banquet-img/man.png" alt="" />
                    先生
                  </div>
                  <div
                    @click="orderInfo.sex = 0"
                    :class="orderInfo.sex === 0 ? 'select' : ''"
                    class="sex"
                  >
                    <img src="@/assets/banquet-img/lady.png" alt="" />
                    女士
                  </div>
                </div>
              </el-row>
            </div>
          </div>
          <div class="flex gap-1">
            <el-row class="r-info flex-1">
              <div class="c-info flex items-center flex-1">
                <el-time-select
                  v-model="orderInfo.arriveTime"
                  :start="arriveTime.starttime"
                  step="00:15"
                  :end="arriveTime.endtime"
                />
                <span class="w-5">到</span>
              </div>
            </el-row>
            <el-row
              v-if="createType !== 3 && createType !== 4"
              class="r-info w-1/2"
            >
              <div class="c-info w-full">
                <el-select
                  popper-class="muti-select-popper"
                  class=""
                  v-model="orderInfo.receiverOrderId"
                  placeholder="请选择接单人"
                >
                  <el-option
                    v-for="r in receiverList"
                    @click="choiceReceiver(r)"
                    :key="r.id"
                    :label="r.name"
                    :value="r.id"
                  ></el-option>
                </el-select>
              </div>
            </el-row>
          </div>
          <el-row v-if="createType == 4" class="r-info flex">
            <div :span="8" class="r-label">预留给</div>
            <div class="c-info flex-1">
              <el-select
                popper-class="muti-select-popper"
                v-model="orderInfo.receiverOrderId"
              >
                <el-option
                  v-for="r in receiverList"
                  @click="choiceReceiver(r)"
                  :key="r.id"
                  :label="r.name"
                  :value="r.id"
                ></el-option>
              </el-select>
            </div>
          </el-row>
          <!-- <el-row v-if="createType !== 1" class="r-info">
          <div :span="8" class="r-label">餐位</div>
          <div
            v-if="desklist.length > 0"
            :title="getDeskName"
            style="
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            class="c-info"
            :span="16"
            ><template v-for="desk in desklist" :key="desk.deskid">{{
              " " + desk.desk.deskname
            }}</template></div
          >
          <div v-else class="c-info" :span="16"
            ><span style="margin-left: 5px; color: #ff5353"
              >请选择餐位</span
            ></div
          >
        </el-row> -->
          <!-- <el-row
          class="r-info"
          v-if="createType !== 1 && cancelDeskName.length > 0"
        >
          <span style="color: #f56c6c">{{ cancelDeskName.join(",") }}</span
          >已被占用
        </el-row> -->
        </div>
        <div class="mt-3 mb-3" style="color: #999999">非必填项</div>
        <div class="w-full flex gap-1">
          <el-row class="r-info flex-1">
            <div class="c-info w-full">
              <el-select
                :disabled="cantselect"
                v-model="orderInfo.customerSource"
                clearable
                placeholder="客户来源"
              >
                <el-option
                  v-for="item in customerSourceList"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictLabel"
                />
              </el-select>
            </div>
          </el-row>
          <el-row
            v-if="createType !== 3 && createType !== 4"
            class="r-info w-1/2"
          >
            <div
              style="cursor: pointer"
              class="c-info flex justify-between items-center"
              @click="showTypebox"
              :span="16"
            >
              <el-input
                style="width: 120px; color: #666666"
                placeholder="用餐类型"
                v-model="orderInfo.banquettypename"
                readonly
              ></el-input>
              <el-icon style="color: #a8abb2"><ArrowDown /></el-icon>
            </div>
          </el-row>
        </div>
        <el-row class="r-info" v-if="createType !== 3 && createType !== 4">
          <div :span="6" class="r-label">客户所在单位</div>
          <div class="c-info" :span="18">
            <el-input v-model="orderInfo.company"></el-input>
          </div>
        </el-row>
        <el-row
          v-if="
            createType !== 3 &&
            createType !== 4 &&
            orderInfo.orderstatus !== '2'
          "
          class="r-info justify-between"
        >
          <div :span="6" class="r-label">订金</div>
          <div
            style="cursor: pointer"
            @click="choiceDeposit"
            :style="depositinfo.amount ? '' : 'color:#999999;'"
            class="c-info"
            :span="18"
          >
            {{
              depositinfo.amount
                ? (depositinfo.date
                    ? formatDate("yyyy-MM-dd", depositinfo.date)
                    : "") +
                  " " +
                  getPayType +
                  depositinfo.amount +
                  "元" +
                  " " +
                  getPayeeValue +
                  "收"
                : "请填写订金信息"
            }}
          </div>
        </el-row>
        <el-row class="r-info" style="height: auto">
          <div class="r-label" :span="2">备注</div>
          <div class="flex-1">
            <el-input
              type="textarea"
              v-model="orderInfo.orderRemark"
            ></el-input>
          </div>
        </el-row>
        <el-row v-if="createType !== 3 && createType !== 4" class="label-list">
          <span
            @click="selectLabel(label)"
            v-for="label in labellist"
            :key="label.labelid"
            :class="selectlabelid.indexOf(label.labelid) >= 0 ? 'select' : ''"
            >{{ label.labelname }}</span
          >
        </el-row>
        <!-- <div
        v-if="createType === 2 && orderInfo.orderstatus !== '2'"
        style="font-size: 16px; margin-left: 5px; font-weight: bold"
      >
        系统通知
      </div>
      <el-row
        v-if="createType === 2 && orderInfo.orderstatus !== '2'"
        class="r-info"
        style="height: auto"
      >
        <div :span="6">
          <el-checkbox
            v-model="isSendMessage"
            label="短信携带桌号"
            size="large"
          />
        </div>
        <div class="c-info" :span="18">
          <el-button style="width: 120px" v-if="desklist.length > 0">{{
            desklist[0].desk.deskname
          }}</el-button>
        </div>
      </el-row> -->
      </div>
      <div class="sticky bottom-0 left-0">
        <div
          v-if="!orderId && [1, 2].includes(createType)"
          style="
            display: flex;
            justify-content: space-around;
            background-color: #ffffff;
            padding-top: 5px;
          "
        >
          <div class="flex justify-around" v-if="desklist.length">
            <el-button
              @click="toSave"
              :loading="loading1"
              class="w-[114px] conston-btn"
              type="danger"
            >
              <img
                style="width: 16px; height: 16px"
                src="@/assets/order/add.png"
                class="mr-1"
              />预订</el-button
            >
            <el-button
              @click="saveAndSend"
              :loading="loading2"
              class="w-[140px] conston-btn"
              type="danger"
            >
              <img
                style="width: 16px; height: 16px"
                src="@/assets/order/add.png"
                class="mr-1"
              />
              <img
                style="width: 16px; height: 16px"
                src="@/assets/order/xinxi.png"
                class="mr-1"
              />预订并短信</el-button
            >
          </div>
          <div v-else class="flex justify-around">
            <el-button
              @click="toSave"
              :loading="loading1"
              class="w-[262px] conston-btn"
              type="danger"
              ><img
                style="width: 16px; height: 16px"
                src="@/assets/order/add.png"
                class="mr-1"
              />预约排队</el-button
            >
          </div>
          <el-button @click="close" class="btn-item" type="danger">
            <img src="@/assets/order/close.png" class="mr-1" />关闭</el-button
          >
        </div>
        <div v-else class="flex justify-around items-center">
          <el-button
            :loading="loading3"
            @click="toSave"
            :disabled="isSaveDisabled"
            style="flex: 1"
            type="danger"
            >{{
              createType === 1
                ? "创建预约单"
                : createType === 3
                ? props.id
                  ? "保存订单"
                  : "散客入座"
                : createType === 4
                ? props.id
                  ? "保存订单"
                  : "创建预留单"
                : "保存订单"
            }}</el-button
          >
          <el-button @click="close" class="btn-item !h-[32px]" type="danger">
            <img src="@/assets/order/close.png" class="mr-1" />关闭</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog style="width: 450px" v-model="deposit" title="填写订金">
      <el-form label-width="100px">
        <el-form-item label="订金金额：">
          <el-input v-model="depositinfo.amount"></el-input>
        </el-form-item>
        <el-form-item label="支付方式：">
          <el-select v-model="depositinfo.type" placeholder="请选择支付方式">
            <el-option
              v-for="type in types"
              :key="type.id"
              :label="type.name"
              :value="type.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收据编号：">
          <el-input v-model="depositinfo.number"></el-input>
        </el-form-item>
        <el-form-item label="收款人：">
          <el-select v-model="depositinfo.payee" placeholder="请选择收款人">
            <el-option
              v-for="payee in payees"
              :key="payee.id"
              :label="payee.name"
              :value="payee.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款时间：">
          <el-date-picker
            v-model="depositinfo.date"
            type="date"
            placeholder="请选择收款时间"
            :disabled-date="limitData"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <div style="text-align: center">
          <el-button type="danger" @click="deposit = false">保存订金</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="用餐类型" style="width: 700px" v-model="typeshow">
      <div class="banquet-type">
        <div class="bt-title">
          <div class="title-list">
            <div
              :class="thetitle === '' ? 'select' : ''"
              @click="selectTitle('')"
              class="title-box"
            >
              全部
            </div>
            <template v-for="(title, index) in titlelist" :key="title.id">
              <div
                v-if="index < 5"
                @click="selectTitle(title)"
                :class="title.id === thetitle.id ? 'select' : ''"
                class="title-box"
              >
                {{ title.name }}
              </div>
            </template>
            <div
              v-if="hidetitle.length > 0"
              style="
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: end;
              "
            >
              <el-dropdown>
                <span>
                  更多
                  <el-icon class="el-icon--right">
                    <arrow-down />
                  </el-icon>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item
                      @click="selectTitle(title)"
                      v-for="title in hidetitle"
                      :key="title.id"
                      >{{ title.name }}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
        </div>
        <div class="bt-body">
          <div class="type-list">
            <div
              :class="thetype.id === type.id ? 'select' : ''"
              @click="selectType(type)"
              v-for="type in typelist"
              :key="type.id"
              class="type-box"
            >
              {{ type.name }}
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="typeshow = false">取消</el-button>
          <el-button type="danger" @click="typeshow = false">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import {
  defineProps,
  onMounted,
  ref,
  computed,
  defineEmits,
  defineExpose,
  nextTick,
  h,
  watch,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
import {
  getPayee,
  saveOrder,
  sendMessage,
  saveFit,
  saveRevered,
  getAllLabel,
  getUserinfoByPhone,
  findRestaurantMealTime,
  setCallRecord,
} from "@/api/home/home";
import { getOrderDeatils } from "@/api/order/index";
import { getPriviledgeAndPocessByUser } from "@/api/system/role";
import { Close, InfoFilled, ArrowDown } from "@element-plus/icons-vue";
import { getBanquetTypeRealtion } from "@/api/home/home";
import { getQueryData } from "@/api/system/config";
import { ElMessage, ElMessageBox } from "element-plus";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { formatDate } from "@/utils/formatdate";
import bus from "@/utils/bus";
const props = defineProps({
  // textarea: String,
  // simple: Boolean,
  // num: {
  //   type: Number,
  //   default: 1,
  // },
  id: {
    type: String,
    default: "2",
  },
  calendar: {
    type: Object,
    default: () => {},
  },
  mealDate: {
    type: String,
    default: "",
  },
  mealtypes: {
    type: Array,
    default: () => [],
  },
});
const num = ref(0);
// const banquetDate = computed(() => store.state.order.date); //当前日期
const isCreate = ref(false);
const textarea = ref("");
const mealDate = ref(formatDate("yyyy-MM-dd", new Date()));
const mealTypeImageList = [
  require("@/assets/banquet-img/zaocan.png"),
  require("@/assets/banquet-img/shangwucha.png"),
  require("@/assets/banquet-img/wucan.png"),
  require("@/assets/banquet-img/xiawucha.png"),
  require("@/assets/banquet-img/wancan.png"),
  require("@/assets/banquet-img/yexiao.png"),
];
const colors = ref({
  sankeBackColor: "#EDF4FF", //最初样式
  //sankeBackColor: '#3E3CF4',//最新样式
  sankeFrontColor: "#448AF8", //最初样式
  //sankeFrontColor: '#F7F7F7',//最新样式
  yvdingBackColor: "#FFA7A7", //最初样式
  //yvdingBackColor: '#E32B3D',//最新样式
  dingBackFotterColor: "#FFA7A7", //最初样式
  //dingBackFotterColor: '#E32B3D', //最新样式
  selectBackColor: "#3F3CFF", //最初样式
  //selectBackColor: '#25B661',//最新样式
});
const loading1 = ref(false);
const loading2 = ref(false);
const loading3 = ref(false);
const simpleAdd = ref(false);
const canchoice = ref(true);
const { loading, closeLoading } =
  getCurrentInstance().appContext.config.globalProperties;
const store = useStore();
const mealtypes = ref([]); //餐段列表
const router = useRouter();
const cansavesend = ref(true);
const cansave = ref(true);
const emit = defineEmits([
  "getDeskList",
  "cancel",
  "save",
  "changeTab",
  "deleteDeskList",
  "close",
  "updateOrder",
]);
const updateData = ref({});
const deposit = ref(false);
const typeshow = ref(false);
const arriveTime = ref({ starttime: "", endtime: "", defaulttime: "" });
const receiverList = ref([]);
const memberinfo = ref({}); // 会员信息
const isSendMessage = ref(true); // 是否发送短信
const labellist = ref([]); //标签列表
const selectlabelid = ref([]); //选中的标签id
const watchDate = computed(() => store.state.order.date); //监听日期
const banquetDate = ref(""); //当前日期
const mealDateEnd = ref(""); //结束日期
const visibleYuLiu = ref(true);
const visibleYuYue = ref(true);
const cantselect = ref(false); //客户来源是否可选
const continuousBookingFlag = ref(0);
const givePopover = ref(null);
const receiverOrderId = ref("");
const receiverOrderName = ref("");
banquetDate.value = store.state.order.date;
mealDateEnd.value = store.state.order.date;
const desklist = computed(() => store.state.order.desklist); //桌位信息
console.log("xxxxx", desklist, store.state.order.desklist);
const mealtype = computed(() => store.state.order.mealtype); //当前餐段
const nowTime = formatDate("yyyy-MM-dd hh:mm", new Date());
const getDeskName = computed(() => {
  let deskname = "";
  for (let desk of desklist.value) {
    deskname += " " + desk.desk.deskname;
  }
  return deskname;
});
const getPayType = computed(() => {
  let t = "";
  for (let type of types.value) {
    if (type.id === depositinfo.value.type) {
      t = type.name;
      break;
    }
  }
  return t;
});
const getPayeeValue = computed(() => {
  let p = "";
  for (let payee of payees.value) {
    if (payee.id === depositinfo.value.payee) {
      p = payee.name;
      break;
    }
  }
  return p;
});
const mealtype_string = computed(() => JSON.stringify(mealtype.value));
watch(watchDate, (newdata) => {
  cancelDeskName.value = [];
  banquetDate.value = newdata;
  mealDateEnd.value = newdata;
});
watch(banquetDate, (newdata) => {
  // store.dispatch('changeDesklist',[])
  if (mealtype.value) {
    findRestaurantMealTime({
      reserveDate: newdata,
      segmentType: mealtype.value.segmenttype,
    })
      .then((res) => {
        if (res.data.code === 200) {
          if (res.data.data.length > 0) {
            let time = res.data.data[0];
            arriveTime.value = {
              starttime: time.starttime,
              endtime: time.endtime,
              defaulttime: time.defaultTime,
            };
            orderInfo.value.arriveTime = time.defaultTime;
          }
        }
      })
      .catch(() => {});
  }
});
const close = () => {
  emit("close");
};
bus.on("getMealType", (data) => {
  if (data) {
    mealtype.value = data;
  }
});
const giveClose = () => {
  givePopover.value.hide();
};
const toGive = () => {
  receiverOrderId.value = "";
  receiverOrderName.value = "";
  receiverList.value = [];
  getPayee()
    .then((res) => {
      for (let d of res.data.data) {
        receiverList.value.push(d);
      }
    })
    .catch(() => {});
};
const selectPeople = (item) => {
  receiverOrderId.value = item.id;
  receiverOrderName.value = item.name;
};
const creatOrder = (params) => {
  const nowTime = formatDate("yyyy-MM-dd hh:mm", new Date());
  if (props.mealDate + " " + mealtype.value.endtime > nowTime) {
    isCreate.value = true;
    reload(params);
    // router.push({
    //   path: "/createorder/2",
    //   query: { num: num.value, textarea: textarea.value, simple: true },
    // });
  } else {
    ElMessage({
      message: "餐段时间已过，不允许创建订单",
      type: "error",
    });
  }
};

const reload = (params) => {
  getContinuousBookingFlag();
  getMealTime();
  getLabel();
  getBanuetType();
  queryPayee();
  nextTick(() => {
    if (params) {
      orderInfo.value.name = params.name;
      orderInfo.value.phone = params.phone;
      recordId.value = params.recordId;
    }
    //增加预约和预留开关
    visibleYuLiu.value = localStorage.getItem("YuLiu") == 1;
    visibleYuYue.value = localStorage.getItem("YuYue") == 1;
    if (props.id !== "1" && props.id !== "2") {
      loading();
      // 订单回显
      setTimeout(() => {
        getOrderDeatils({ orderid: props.id })
          .then((res) => {
            if (res.data.code === 200) {
              closeLoading();
              let data = res.data.data;
              updateData.value = data;
              switch (data.orderType) {
                case "2":
                  createType.value = 4;
                  break;
                case "3":
                  createType.value = 1;
                  break;
                case "4":
                  createType.value = 3;
                  break;
                default:
                  createType.value = 2;
              }
              if (createType.value === 3 || createType.value === 4) {
                store.dispatch("canselectdesk", false);
              }
              orderId.value = data.orderid;
              let deskarr = [];
              // desklist.value = [];
              for (let el of data.deskStatisticsVoList) {
                let desk = {
                  desk: {
                    deskname: el.tablename,
                    deskid: el.tableId,
                  },
                };
                deskarr.push(desk);
                //  desklist.value.push(desk);
              }
              store.dispatch("changeDesklist", deskarr);
              // // 选中桌位回显
              bus.emit("deskshow", deskarr);
              orderInfo.value = {
                name: data.fullName,
                sex: Number(data.sex === null ? 1 : data.sex),
                phone: data.phone,
                arriveTime: data.arriveTime,
                company: data.unitName,
                customerSource: data.customerSource,
                receiverOrderName: data.receiverOrderName,
                receiverOrderId: data.receiverOrderId,
                wechatid: data.weChatId,
                // serviceLevel:{
                //     classid:'',
                //     classname:'',
                // },
                number: data.reservedPeoples,
                orderRemark: data.orderRemark,
                banquettype: data.typeid,
                banquettypename: data.typename,
                orderstatus: data.orderStatus + "",
              };
              if (data.typename === "随客转化") {
                canchoice.value = false;
              } else {
                canchoice.value = true;
              }
              if (data.banquetDepositDetails) {
                depositinfo.value = {
                  amount: data.banquetDepositDetails.amount,
                  type: data.banquetDepositDetails.paytype
                    ? Number(data.banquetDepositDetails.paytype)
                    : "",
                  number: data.banquetDepositDetails.receiptid,
                  payee: data.banquetDepositDetails.payeeid,
                  date: data.banquetDepositDetails.paytime,
                };
              }
              if (data.banquetLabelList) {
                selectlabelid.value = data.banquetLabelList;
              }
            }
          })
          .catch(() => {});
      }, 1000);
    }
    getQueryData("sys_customer_source")
      .then((res) => {
        customerSourceList.value = [];
        if (res.data.code == 200) {
          let list = res.data.data;
          list.forEach((item) => {
            if (
              item.dictLabel === "自行来店" &&
              !orderInfo.value.customerSource
            ) {
              orderInfo.value.customerSource = item.dictLabel;
            }
            customerSourceList.value.push({
              dictCode: item.dictCode,
              dictLabel: item.dictLabel,
            });
          });
        }
      })
      .catch(() => {});
    if (banquetDate.value && mealtype.value.segmenttype) {
      findRestaurantMealTime({
        reserveDate: banquetDate.value,
        segmentType: mealtype.value.segmenttype,
      })
        .then((res) => {
          if (res.data.code === 200) {
            if (res.data.data.length > 0) {
              let time = res.data.data[0];
              arriveTime.value = {
                starttime: time.starttime,
                endtime: time.endtime,
                defaulttime: time.defaultTime,
              };
              if (!orderInfo.value.arriveTime && !orderId.value) {
                orderInfo.value.arriveTime = time.defaultTime;
              }
              bus.emit("getMealType", res.data.data[0]);
            }
          }
        })
        .catch(() => {});
    }
  });
};

const getContinuousBookingFlag = () => {
  getPriviledgeAndPocessByUser().then((res) => {
    continuousBookingFlag.value =
      res.data.data.lstProcess.continuousBookingFlag;
  });
};
// getContinuousBookingFlag();
const showTypebox = () => {
  if (canchoice.value) {
    typeshow.value = true;
  }
};
// 选择餐段
const changeMealDate = (bol, obj) => {
  if (bol) {
    return;
  }
  sessionStorage.setItem("mealtype", JSON.stringify(obj));
  store.dispatch("changeMealtype", JSON.parse(JSON.stringify(obj)));
};
const getMealTime = () => {
  // 获取餐段信息
  findRestaurantMealTime()
    .then((res) => {
      const date = new Date();
      if (res.data.code === 200) {
        let week = date.getDay();
        let timearr = [];
        let data = res.data.data;
        if (week === 0) {
          week = 7;
        }
        for (let i = 0, len = data.length; i < len; i++) {
          let times = data[i];
          if (times.weekday === week) {
            timearr.push(times);
            mealtypes.value.push({
              segmenttype: times.segmenttype,
              segmentname: times.segmentname,
              endtime: times.endtime,
            });
          }
        }
      }
    })
    .catch(() => {});
};
const deleteDeskList = (desk) => {
  desk.select = true;
  emit("deleteDeskList", desk);
};
onBeforeUnmount(() => {
  //bus.off("getMealType");
});
const banquetDate_String = computed(() => JSON.stringify(desklist.value));
const customerSourceList = ref([]);
const orderId = ref("");
const isBook = ref(false);
const createType = ref(1);
const isSaveDisabled = ref(false);
const recordId = ref(null); //来电记录用
// 订单信息
const orderInfo = ref({
  name: "",
  sex: 1,
  phone: "",
  wechatid: "",
  company: "",
  arriveTime: "",
  customerSource: "",
  // serviceLevel:{
  //     classid:'',
  //     classname:'',
  // },
  number: "",
  receiverOrderId: "",
  receiverOrderName: "",
  orderRemark: "",
  banquettype: "",
  banquettypename: "",
  orderstatus: "",
});
// 订金信息
const depositinfo = ref({
  amount: "",
  type: "",
  number: "",
  payee: "",
  date: new Date(),
});
// orderInfo.value.number = computed(() => {
//   if (props.id === "2") {
//     let n = 0;
//     desklist.value.forEach((p) => {
//       n += p.desk.peoplemin;
//     });
//     return n;
//   } else {
//     return orderInfo.value.number;
//   }
// });
const changeDate = (obj) => {
  store.dispatch("changeDate", formatDate("yyyy-MM-dd", obj));
};
if (props.id !== "1" && props.id !== "2") {
  createType.value = Number(props.id);
}
if (props.id === "1") {
  isBook.value = true;
}
if (router.currentRoute.value.query.name) {
  orderInfo.value.name = router.currentRoute.value.query.name;
  orderInfo.value.phone = router.currentRoute.value.query.phone;
}
if (router.currentRoute.value.query.recordId) {
  recordId.value = router.currentRoute.value.query.recordId;
  orderInfo.value.name = router.currentRoute.value.query.name;
  orderInfo.value.phone = router.currentRoute.value.query.phone;
}
const cancelDeskName = ref([]);
bus.on("canceldesk", (el) => {
  cancelDeskName.value.push(el.desk.deskname);
});
// 用户等级
// const serviceLevel = ref([]);
const types = ref([
  { name: "现金", id: 1 },
  { name: "刷卡", id: 2 },
  { name: "微信", id: 3 },
  { name: "支付宝", id: 4 },
]);
const payees = ref([]);
const queryPayee = () => {
  // 获取收款人
  getPayee()
    .then((res) => {
      for (let d of res.data.data) {
        payees.value.push(d);
        receiverList.value.push(d);
        if (d.name === "预订台") {
          orderInfo.value.receiverOrderId = d.id;
          orderInfo.value.receiverOrderName = d.name;
        } else if (d.currentLoginUser && !orderInfo.value.receiverOrderId) {
          orderInfo.value.receiverOrderId = d.id;
          orderInfo.value.receiverOrderName = d.name;
        }
      }
    })
    .catch(() => {});
};

// 选择接单人
const choiceReceiver = (data) => {
  orderInfo.value.receiverOrderName = data.name;
};
const choiceDeposit = () => {
  deposit.value = true;
};
// 获取用户服务等级
// const getLevel = ()=> getServiceLevel().then(res=>{
//     if(res.data.code===200){
//         serviceLevel.value = res.data.data;
//     }
// })
// 获取所有标签
const getLabel = () => {
  let addLabel = (data) => {
    labellist.value = [];
    for (let el of data) {
      labellist.value.push(el);
    }
  };
  getAllLabel({ labeltype: 1 })
    .then((res) => {
      if (res.data.code === 200) {
        addLabel(res.data.data);
      }
    })
    .catch(() => {});
};
// 选择标签
const selectLabel = (label) => {
  let index = selectlabelid.value.indexOf(label.labelid);
  if (index < 0) {
    selectlabelid.value.push(label.labelid);
    orderInfo.value.orderRemark += " " + label.labelname;
  } else {
    selectlabelid.value.splice(index, 1);
    orderInfo.value.orderRemark = orderInfo.value.orderRemark.replaceAll(
      " " + label.labelname,
      ""
    );
  }
};
// ********选择宴会类型********
// 父级类型
let titlelist = ref([]);
// 隐藏的父级类型
let hidetitle = ref([]);
// 宴会类型
let typelist = ref([]);
// 选中的父类型
let thetitle = ref("");
// 选中的宴会类型
let thetype = ref("");
// 所有的宴会类型
let alltypelist = ref([]);
// 获取宴会类型
const getBanuetType = () => {
  getBanquetTypeRealtion()
    .then((res) => {
      titlelist.value = res.data.data;
      hidetitle.value = [];
      for (let i = 0, len = titlelist.value.length; i < len; i++) {
        let data = titlelist.value[i];
        if (i > 4) {
          hidetitle.value.push(data);
        }
        for (let el of data.children) {
          if (el.name == "普通用餐" && !orderInfo.value.banquettypename) {
            orderInfo.value.banquettype = el.id;
            orderInfo.value.banquettypename = el.name;
          }
          typelist.value.push(el);
          alltypelist.value.push(el);
        }
      }
    })
    .catch(() => {});
};
// 选中父类型
const selectTitle = (obj) => {
  thetitle.value = obj;
  if (thetitle.value === "") {
    typelist.value = JSON.parse(JSON.stringify(alltypelist.value));
  } else {
    typelist.value = JSON.parse(JSON.stringify(obj.children));
  }
};
// 选中宴会类型
const selectType = (obj) => {
  thetype.value = obj;
  orderInfo.value.banquettype = obj.id;
  orderInfo.value.banquettypename = obj.name;
};
// ********选择宴会类型----end---********
const onPhoneKeyup = () => {
  if (orderInfo.value.phone.length == 11) {
    editPhoneInfo();
  }
};

const onPhoneWeChatBlur = () => {
  if (
    orderInfo.value.phone.length == 0 &&
    orderInfo.value.wechatid.length == 0
  ) {
    ElMessage({
      message: "电话和微信，二者必填一个",
      grouping: true,
      type: "error",
    });
  } else {
    editPhoneInfo();
  }
};
// 根据电话获取用户信息
const editPhoneInfo = () => {
  if (orderInfo.value.name) {
    return false;
  }
  const params = {
    phone: orderInfo.value.phone,
    wechatid: orderInfo.value.wechatid,
    eatDate: banquetDate.value,
    segmentType: mealtype.value.segmenttype,
  };
  getUserinfoByPhone(params)
    .then((res) => {
      console.log(res);
      if (res.data.code === 200) {
        let arrData = res.data.data;
        let isBlackList = 0;

        if (arrData.length > 0) {
          if (!arrData[0].customerid) {
            return;
          }
          orderInfo.value.name = arrData[0].fullname;
          orderInfo.value.sex = Number(
            arrData[0].sex === null ? 1 : arrData[0].sex
          );
          orderInfo.value.company = arrData[0].unitname;
          orderInfo.value.wechatid = arrData[0].wechatid;
          if (arrData[0].customerSource) {
            orderInfo.value.customerSource = arrData[0].customerSource;
            cantselect.value = true;
          } else {
            cantselect.value = false;
          }
          isBlackList = arrData[0].isBlackList;

          if (isBlackList == 1) {
            isSaveDisabled.value = true;
            ElMessage({
              message: arrData[0].orderInfo
                ? arrData[0].orderInfo
                : orderInfo.value.name + "是预订黑名单客户，不能预订！",
              grouping: true,
              type: "error",
            });
          } else {
            memberinfo.value = arrData[0];
            isSaveDisabled.value = false;
          }
        }
      } else {
        ElMessage({
          message: res.data.msg,
          grouping: true,
          type: "error",
        });
      }
    })
    .catch(() => {});
};
// 保存并发送短信
const saveAndSend = () => {
  if (!cansavesend.value) {
    return false;
  }
  if (desklist.value.length === 0) {
    ElMessage({
      message: "请先选择桌位",
      grouping: true,
      type: "error",
    });
  } else {
    cansavesend.value = false;
    let deskids = [];
    let desknames = [];
    if (props.id !== "1") {
      for (let el of desklist.value) {
        deskids.push(el.desk.deskid);
        desknames.push(el.desk.deskname);
      }
    }
    const params = {
      orderId: orderId.value,
      mealDate: banquetDate.value,
      segmentType: mealtype.value.segmenttype,
      deposit: depositinfo.value.amount,
      peopleNum: orderInfo.value.number,
      arriveTime: orderInfo.value.arriveTime,
      // customerClassId:orderInfo.value.serviceLevel.classid,
      banquetTypeId: orderInfo.value.banquettype,
      receiverOrderName: orderInfo.value.receiverOrderName,
      receiverOrderId: orderInfo.value.receiverOrderId,
      tableIds: deskids,
      customer: {
        phone: orderInfo.value.phone,
        wechatid: orderInfo.value.wechatid,
        sex: orderInfo.value.sex,
        fullname: orderInfo.value.name,
        unitname: orderInfo.value.company,
        customerSource: orderInfo.value.customerSource,
      },
      banquetDepositDetails: {
        amount: depositinfo.value.amount,
        payeeid: depositinfo.value.payee,
        payee: getPayeeValue.value,
        paytime: depositinfo.value.date,
        paytype: depositinfo.value.type,
        receiptid: depositinfo.value.number,
      },
      labelId: selectlabelid.value,
      orderRemark: orderInfo.value.orderRemark,
      source: "web",
    };
    loading2.value = true;
    saveOrder(params)
      .then((res) => {
        cansavesend.value = true;
        if (res.data.code === 200) {
          let params = "/" + res.data.data.orderId;
          if (isSendMessage.value) {
            params = params + "/" + desknames.join("、");
          }
          console.log(params);

          ElMessage({
            message: "保存成功！",
            grouping: true,
            type: "success",
          });
          emit("getDeskList");

          sendMessage(params)
            .then((r) => {
              if (r.data.code === 200) {
                ElMessage({
                  message: "短信发送成功！",
                  grouping: true,
                  type: "success",
                });
              } else {
                ElMessage({
                  message: "已预订成功，完善客户电话后可补发短信！",
                  grouping: true,
                  type: "error",
                });
              }
              //来电记录更行
              callToRefresh();
              emit("save");
              //router.push({ path: "/index" });
            })
            .catch(() => {});
        } else {
          ElMessage({
            message: res.data.msg,
            grouping: true,
            type: "error",
          });
        }
      })
      .finally(() => {
        setTimeout(() => {
          loading2.value = false;
        }, 1000);
      })
      .catch(() => {});
  }
};
// 点击保存按钮
const toSave = () => {
  console.log("桌位数量：" + desklist.value.length);
  if (desklist.value.length > 0) {
    saveOrderData();
  } else if (createType.value !== 1) {
    ElMessageBox({
      message: h("p", null, [
        h("span", null, "您没有选择餐位，是否创建"),
        h(
          "i",
          { style: "color: rgb(255, 83, 83);font-style:normal;" },
          "预约单"
        ),
      ]),
      type: "warning",
      showCancelButton: true,
      cancelButtonText: "重新选择桌位",
      confirmButtonText: "创建",
    }).then(() => {
      saveOrderData();
    });
  } else {
    saveOrderData();
  }
};
// 禁用订金选择日期
const limitData = (date) => {
  if (formatDate("yyyy-MM-dd", date) <= formatDate("yyyy-MM-dd", new Date())) {
    return false;
  } else {
    return true;
  }
};

const daysBetween = (date1, date2) => {
  const oneDay = 24 * 60 * 60 * 1000; // 每天的毫秒数
  const firstDate = new Date(date1);
  const secondDate = new Date(date2);

  // 计算时间差
  const diff = Math.abs(firstDate - secondDate);

  // 返回差值除以每天的毫秒数
  return Math.round(diff / oneDay);
};
// 保存订单
const saveOrderData1 = (createType) => {
  console.log("是否能存储：" + cansave.value);
  if (!cansave.value) {
    return false;
  }
  cansave.value = false;
  let deskids = [];
  // if(router.currentRoute.value.params.id!=='1'){
  //     for(let el of desklist.value){
  //         deskids.push(el.desk.deskid);
  //     }
  // }
  if (createType === 3) {
    const params = {
      orderId: "", //orderId.value,
      mealDate: banquetDate.value,
      segmentType: mealtype.value.segmenttype,
      tableIds: desklist.value.map((p) => p.desk.deskid),
      arriveTime: orderInfo.value.arriveTime,
      peopleNum: orderInfo.value.number,
     // customerRemark: textarea.value,
      orderRemark:textarea.value,
      customer: {
        phone: orderInfo.value.phone,
        wechatid: orderInfo.value.wechatid,
        sex: orderInfo.value.sex,
        fullname: orderInfo.value.name,
        unitname: orderInfo.value.company,
        customerSource: orderInfo.value.customerSource,
      },
    };
    loading1.value = true;
    //保存散客
    saveFit(params)
      .then((res) => {
        cansave.value = true;
        if (res.data.code === 200) {
          ElMessage({
            message: res.data.msg,
            grouping: true,
            type: "success",
          });
          emit("getDeskList");
          //来电记录更行
          // callToRefresh()

          emit("save");
          router.push({ path: "/index" });
        } else {
          ElMessage({
            message: res.data.msg,
            grouping: true,
            type: "error",
          });
        }
      })
      .finally(() => {
        loading1.value = false;
      })
      .catch(() => {});
  } else if (createType === 4) {
    if (!receiverOrderId.value) {
      ElMessage({
        message: "请选择预留人员",
        grouping: true,
        type: "error",
      });
      return;
    }
    const params = {
      orderId: "", //orderId.value,
      mealDate: banquetDate.value,
      segmentType: mealtype.value.segmenttype,
      tableIds: desklist.value.map((p) => p.desk.deskid),
      arriveTime: orderInfo.value.arriveTime,
      peopleNum: orderInfo.value.number,
      receiverOrderName: receiverOrderName.value,
      receiverOrderId: receiverOrderId.value,
      orderRemark:textarea.value,
      customer: {
        phone: orderInfo.value.phone,
        wechatid: orderInfo.value.wechatid,
        sex: orderInfo.value.sex,
        fullname: orderInfo.value.name,
        unitname: orderInfo.value.company,
        customerSource: orderInfo.value.customerSource,
      },
    };
    loading2.value = true;
    //保存预留
    saveRevered(params)
      .then((res) => {
        cansave.value = true;
        if (res.data.code === 200) {
          ElMessage({
            message: res.data.msg,
            grouping: true,
            type: "success",
          });
          emit("getDeskList");
          //来电记录更行
          // callToRefresh()

          emit("save");
          router.push({ path: "/index" });
        } else {
          ElMessage({
            message: res.data.msg,
            grouping: true,
            type: "error",
          });
        }
      })
      .finally(() => {
        loading2.value = false;
      })
      .catch(() => {});
  } else {
    if (
      orderInfo.value.phone.length == 0 &&
      orderInfo.value.wechatid.length == 0 &&
      createType.value < 3
    ) {
      cansave.value = true;
      ElMessage({
        message: "电话和微信，二者必填一个",
        grouping: true,
        type: "error",
      });
      return;
    }
    const params = {
      orderId: orderId.value,
      mealDate: banquetDate.value,
      segmentType: mealtype.value.segmenttype,
      deposit: depositinfo.value.amount,
      peopleNum: orderInfo.value.number,
      arriveTime: orderInfo.value.arriveTime,
      // customerClassId:orderInfo.value.serviceLevel.classid,
      banquetTypeId: orderInfo.value.banquettype,
      receiverOrderName: orderInfo.value.receiverOrderName,
      receiverOrderId: orderInfo.value.receiverOrderId,
      customer: {
        phone: orderInfo.value.phone,
        wechatid: orderInfo.value.wechatid,
        sex: orderInfo.value.sex,
        fullname: orderInfo.value.name,
        unitname: orderInfo.value.company,
        customerSource: orderInfo.value.customerSource,
      },
      banquetDepositDetails: {
        amount: depositinfo.value.amount,
        payeeid: depositinfo.value.payee,
        payee: getPayeeValue.value,
        paytime: depositinfo.value.date,
        paytype: depositinfo.value.type,
        receiptid: depositinfo.value.number,
      },
      labelId: selectlabelid.value,
      orderRemark: orderInfo.value.orderRemark,
      source: "web",
    };
    if (continuousBookingFlag.value === 1 && [2].includes(createType.value)) {
      params.mealDateEnd = formatDate("yyyy-MM-dd", mealDateEnd.value);
      if (
        new Date(params.mealDate).valueOf() >
        new Date(params.mealDateEnd).valueOf()
      ) {
        cansave.value = true;
        ElMessage({
          message: "预定日期不能大于结束日期",
          grouping: true,
          type: "error",
        });
        return;
      }
      if (daysBetween(params.mealDate, params.mealDateEnd) > 30) {
        ElMessage({
          message: "预定日期跟结束日期之间不能大于30天",
          grouping: true,
          type: "error",
        });
        return;
      }
    }
    if (createType.value === 2 || orderId.value !== "") {
      params.tableIds = deskids;
    }
    saveOrder(params)
      .then((res) => {
        cansave.value = true;
        if (res.data.code === 200) {
          ElMessage({
            message: "保存成功！",
            grouping: true,
            type: "success",
          });
          emit("getDeskList");
          //来电记录更行
          //callToRefresh()
          emit("save");
          if (deskids.length > 0) {
            router.push({ path: "/index" });
          } else {
            router.push({ path: "/todayorder" });
          }
        } else {
          ElMessage({
            message: res.data.msg,
            grouping: true,
            type: "error",
          });
        }
      })
      .catch(() => {});
  }
};
const tips = (params, cb) => {
  if (Object.keys(updateData.value).length > 0) {
    console.log("params", updateData.value, params);
    const { eatdate, segmenttype, segmentName } = updateData.value;
    if (eatdate === params.mealDate && segmenttype === params.segmentType) {
      cb && cb();
    } else {
      let text = "";
      const cd = mealtypes.value.filter(
        (p) => p.segmenttype === params.segmentType
      )[0]?.segmentname;
      const dateArr0 = eatdate.split("-");
      const dat0 = dateArr0[0] + "年" + dateArr0[1] + "月" + dateArr0[2] + "日";
      const dateArr = params.mealDate.split("-");
      const dat = dateArr[0] + "年" + dateArr[1] + "月" + dateArr[2] + "日";
      if (eatdate !== params.mealDate && segmenttype !== params.segmentType) {
        text = "就餐日期和餐段将修改为“" + dat + " " + cd + "”，是否确认修改？";
      } else if (
        eatdate !== params.mealDate &&
        segmenttype === params.segmentType
      ) {
        text = "就餐日期将由“" + dat0 + "” 修改为“" + dat + "”，是否确认修改？";
      } else if (
        eatdate === params.mealDate &&
        segmenttype !== params.segmentType
      ) {
        text =
          "餐段将由“" + segmentName + "” 修改为“" + cd + "”，是否确认修改？";
      }
      ElMessageBox.alert(text, "提示", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action === "confirm") {
            cb && cb();
          }
        },
      });
    }
  } else {
    cb && cb();
  }
};
// 保存订单
const saveOrderData = () => {
  // console.log("是否能存储：" + cansave.value);
  // if (!cansave.value) {
  //   return false;
  // }
  // cansave.value = false;
  let deskids = [];
  if (props.id !== "1") {
    for (let el of desklist.value) {
      deskids.push(el.desk.deskid);
    }
  }
  if (createType.value === 3) {
    const params = {
      orderId: orderId.value,
      mealDate: banquetDate.value,
      segmentType: mealtype.value.segmenttype,
      tableIds: deskids,
      arriveTime: orderInfo.value.arriveTime,
      peopleNum: orderInfo.value.number,
      customerRemark: orderInfo.value.orderRemark,
      customer: {
        phone: orderInfo.value.phone,
        wechatid: orderInfo.value.wechatid,
        sex: orderInfo.value.sex,
        fullname: orderInfo.value.name,
        unitname: orderInfo.value.company,
        customerSource: orderInfo.value.customerSource,
      },
    };
    tips(params, () => {
      loading3.value = true;
      //保存散客
      saveFit(params)
        .then((res) => {
          cansave.value = true;
          if (res.data.code === 200) {
            ElMessage({
              message: res.data.msg,
              grouping: true,
              type: "success",
            });
            emit("getDeskList");
            //来电记录更行
            //callToRefresh();
            emit("save");
            router.push({ path: "/index" });
          } else {
            ElMessage({
              message: res.data.msg,
              grouping: true,
              type: "error",
            });
          }
        })
        .finally(() => {
          loading3.value = false;
        });
    });
  } else if (createType.value === 4) {
    const params = {
      orderId: orderId.value,
      mealDate: banquetDate.value,
      segmentType: mealtype.value.segmenttype,
      tableIds: deskids,
      arriveTime: orderInfo.value.arriveTime,
      peopleNum: orderInfo.value.number,
      receiverOrderName: orderInfo.value.receiverOrderName,
      receiverOrderId: orderInfo.value.receiverOrderId,
      customerRemark: orderInfo.value.orderRemark,
      customer: {
        phone: orderInfo.value.phone,
        wechatid: orderInfo.value.wechatid,
        sex: orderInfo.value.sex,
        fullname: orderInfo.value.name,
        unitname: orderInfo.value.company,
        customerSource: orderInfo.value.customerSource,
      },
    };
    tips(params, () => {
      loading3.value = true;
      //保存预留
      saveRevered(params)
        .then((res) => {
          cansave.value = true;
          if (res.data.code === 200) {
            ElMessage({
              message: res.data.msg,
              grouping: true,
              type: "success",
            });
            emit("getDeskList");
            //来电记录更行
            // callToRefresh();
            emit("save");
            router.push({ path: "/index" });
          } else {
            ElMessage({
              message: res.data.msg,
              grouping: true,
              type: "error",
            });
          }
        })
        .finally(() => {
          loading3.value = false;
        });
    });
  } else {
    if (createType.value < 3) {
      createType.value = desklist.value.length > 0 ? 2 : 1;
    }
    if (
      orderInfo.value.phone?.length == 0 &&
      orderInfo.value.wechatid?.length == 0 &&
      createType.value < 3
    ) {
      cansave.value = true;
      ElMessage({
        message: "电话和微信，二者必填一个",
        grouping: true,
        type: "error",
      });
      return;
    }
    if (orderInfo.value.name?.length == 0 && createType.value < 3) {
      cansave.value = true;
      ElMessage({
        message: "请输入客户姓名！",
        grouping: true,
        type: "error",
      });
      return;
    }

    const params = {
      orderId: orderId.value,
      mealDate: banquetDate.value,
      segmentType: mealtype.value.segmenttype,
      deposit: depositinfo.value.amount,
      peopleNum: orderInfo.value.number,
      arriveTime: orderInfo.value.arriveTime,
      // customerClassId:orderInfo.value.serviceLevel.classid,
      banquetTypeId: orderInfo.value.banquettype,
      receiverOrderName: orderInfo.value.receiverOrderName,
      receiverOrderId: orderInfo.value.receiverOrderId,
      customer: {
        phone: orderInfo.value.phone,
        wechatid: orderInfo.value.wechatid,
        sex: orderInfo.value.sex,
        fullname: orderInfo.value.name,
        unitname: orderInfo.value.company,
        customerSource: orderInfo.value.customerSource,
      },
      banquetDepositDetails: {
        amount: depositinfo.value.amount,
        payeeid: depositinfo.value.payee,
        payee: getPayeeValue.value,
        paytime: depositinfo.value.date,
        paytype: depositinfo.value.type,
        receiptid: depositinfo.value.number,
      },
      labelId: selectlabelid.value,
      orderRemark: orderInfo.value.orderRemark,
      source: "web",
    };
    if (continuousBookingFlag.value === 1 && [2].includes(createType.value)) {
      params.mealDateEnd = formatDate("yyyy-MM-dd", mealDateEnd.value);
      if (
        new Date(params.mealDate).valueOf() >
        new Date(params.mealDateEnd).valueOf()
      ) {
        cansave.value = true;
        ElMessage({
          message: "预定日期不能大于结束日期",
          grouping: true,
          type: "error",
        });
        return;
      }
      if (daysBetween(params.mealDate, params.mealDateEnd) > 30) {
        ElMessage({
          message: "预定日期跟结束日期之间不能大于30天",
          grouping: true,
          type: "error",
        });
        return;
      }
    }
    if (createType.value === 2 || orderId.value !== "") {
      params.tableIds = deskids;
    }
    tips(params, () => {
      loading1.value = true;
      saveOrder(params)
        .then((res) => {
          cansave.value = true;
          if (res.data.code === 200) {
            ElMessage({
              message: "保存成功！",
              grouping: true,
              type: "success",
            });
            emit("getDeskList");
            //来电记录更行
            // callToRefresh();
            emit("save");
            if (deskids.length > 0) {
              router.push({ path: "/index" });
            } else {
              router.push({ path: "/todayorder" });
            }
          } else {
            ElMessage({
              message: res.data.msg,
              grouping: true,
              type: "error",
            });
          }
        })
        .finally(() => {
          setTimeout(() => {
            loading1.value = false;
          }, 1000);
        })
        .catch(() => {});
    });
  }
};
// 页面返回
const Cancel = async () => {
  // await bus.emit("getTable");
  // router.push({ path: "/index" });
  isCreate.value = false;
};

//保存好后，提醒给来电记录进行更新操作
const callToRefresh = () => {
  if (recordId.value !== null) {
    setTimeout(() => {
      let name = mealtypes.value
        .filter((item) => item.segmenttype == mealtype.value.segmenttype)
        .shift().segmentname;
      let formatString = formatDate("MM月dd日", banquetDate.value);
      setCallRecord(recordId.value, formatString + " " + name).then(() => {
        bus.emit("refreshCallList");
      });
    }, 2000);
  }
};
onBeforeUnmount(() => {
  // store.dispatch("changeDesklist", []);
  // store.dispatch("canselectdesk", true);
});
onMounted(() => {
  // const { num, textarea, simple } = props;
  if (props.id === "2") {
    let n = 0;
    desklist.value.forEach((p) => {
      n += p.desk.peoplemin;
    });
    orderInfo.value.number = n;
  }
  // if (num.value) {
  //   setTimeout(() => {
  //     orderInfo.value.number = num.value;
  //   }, 500);
  // }
  if (textarea.value) {
    orderInfo.value.orderRemark = textarea.value;
  }
  //if (simple.value !== undefined) {
  simpleAdd.value = true;
  //}

  // getMealTime();
  // getLevel();
  // getLabel();
  // getBanuetType();
  // queryPayee();

  watch(mealtype_string, () => {
    // if(newdata.segmenttype!==olddata.segmenttype&&olddata.segmenttype!==undefined){
    // store.dispatch('changeDesklist',[])
    if (banquetDate.value && mealtype.value) {
      cancelDeskName.value = [];
      findRestaurantMealTime({
        reserveDate: banquetDate.value,
        segmentType: mealtype.value.segmenttype,
      })
        .then((res) => {
          if (res.data.code === 200) {
            if (res.data.data.length > 0) {
              let time = res.data.data[0];
              arriveTime.value = {
                starttime: time.starttime,
                endtime: time.endtime,
                defaulttime: time.defaultTime,
              };
              orderInfo.value.arriveTime = time.defaultTime;
            }
          }
        })
        .catch(() => {});
    }
    // }
  });
  // 人数默认值
  watch(
    banquetDate_String,
    (newdata, olddata) => {
      let num = 0;
      if (olddata) {
        for (let o of JSON.parse(olddata)) {
          num += o.desk.peoplemin;
        }
      }
      // 通过旧值和类型判断餐位人数是否被手动修改过
      if (num === orderInfo.value.number || num === 0) {
        num = 0;
        for (let n of JSON.parse(newdata)) {
          if (n.desk.peoplemin) {
            num += n.desk.peoplemin;
          }
        }
        if (num !== 0 || !orderInfo.value.number) {
          orderInfo.value.number = num;
        }
      }
    },
    { immediate: true }
  );
});
defineExpose({ reload, orderId, creatOrder });
</script>
<style>

.sexbox {
  display: flex;
  margin-left: 10px;
}
.sexbox img {
  height: 20px;
  width: 16px;
  display: inline-block;
}
.sex {
  width: 60px;
  text-align: center;
  border: 1px solid #f5f5f5;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
}
.sexbox .select {
  border-color: #ee1d23;
}

</style>
<style lang="scss" scoped>

.hall-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, 100px);
  justify-content: space-between;
  grid-row-gap: 6px;
}
.hall-name {
  font-size: 16px;
  font-weight: bold;
  padding: 14px 0;
  padding-bottom: 8px;
}
.hall {
  border: 1px solid #e5e5e5;
  border-radius: 9px 9px 9px 9px;
  overflow: hidden;
  cursor: pointer;
}
.hall {
  text-align: center;
}
/* .desk-name {
  padding-top: 6px;
} */
.select-deskbox {
  color: #ffffff;
  background: var(--select-back-color);
  position: relative;
}
.select-desk {
  padding: 15px 10px 35px;
}
.create-order {
  ::v-deep {
    .el-textarea__inner,
    .el-input__wrapper,
    .el-select__wrapper {
      box-shadow: none;
      background: linear-gradient(180deg, #fafafa 0%, #f0f0f0 100%);
    }
  }
}
.gridbox {
  display: grid;
  grid-template-columns: repeat(auto-fill, 100%);
  justify-content: space-between;
  grid-row-gap: 0px;
}
.create-order {
  height: 100%;
  background-color: #ffffff;
  /* padding: 10px 30px; */
  display: flex;
  flex-direction: column;
}
.r-info {
  background: #f5f5f5;
  padding: 0px 15px;
  margin-bottom: 5px;
  border-radius: 2px;
  align-items: center;
  height: 34px;
  padding-right: 6px;
  border: 1px solid #e6e6e6;
  background: linear-gradient(180deg, #fafafa 0%, #f0f0f0 100%);
  border-radius: 4px 4px 0px 0px;
  .r-label {
    color: #666666;
  }
}
.r-info :deep(.div-6) {
  display: flex;
  align-items: center;
}
.create-order :deep(.el-input__inner) {
  /* text-align: right; */
}
.memberbox {
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 10px;
  background-color: #f9dcbc;
  color: #be8827;
}
.membertitle {
  display: inline-block;
  width: 70px;
}
.c-info {
  text-align: right;
}
.textblock {
  display: inline-block;
  width: 100%;
  height: 100%;
  cursor: pointer;
  text-align: right;
}
.label-list {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.label-list span {
  font-size: 12px;
  color: #666666;
  padding: 2px;
  background-color: #f2f3f5;
  border: 1px solid #c8c9cc;
  border-radius: 2px;
  margin-right: 10px;
  cursor: pointer;
  margin-top: 5px;
}
.label-list .select {
  color: #2da641;
  background-color: #f0faf2;
  border-color: #66be74;
}
.inputbox {
  flex: 1;
  /* overflow: auto; */
}
/* 滚动条整体样式 */
/*.inputbox::-webkit-scrollbar {
    display: none;
}*/

/*定义滚动条的轨道颜色、内阴影及圆角*/
/*.inputbox::-webkit-scrollbar-track{
    display: none;
}*/

/*定义滑块颜色、内阴影及圆角*/
/*.inputbox::-webkit-scrollbar-thumb{
    display: none;
}*/

.ordertype-box {
  flex: 1;
  display: flex;
  margin-left: 20px;
}
.ordertype-box div {
  width: 60px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border-bottom: 2px solid #ffffff;
  cursor: pointer;
}
.ordertype-box .select {
  font-weight: bold;
  border-bottom: 2px solid #fe5353;
}
.title-list {
  display: flex;
  min-width: 460px;
  background: #f5f5f5;
  padding-right: 10px;
}
.title-list .select {
  color: #3f3cff;
}
.title-box {
  height: 36px;
  line-height: 36px;
  padding: 0 10px;
  cursor: pointer;
}
.type-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, 33%);
  justify-content: space-between;
  grid-template-rows: repeat(auto-fill, 32px);
}
.type-list .select {
  background: #fff4f2;
}
.type-box {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  padding-left: 10px;
  line-height: 30px;
}
.type-list {
  height: 350px;
  overflow: auto;
}

/* 设置滚动条的样式 */
.type-list::-webkit-scrollbar {
  width: 2px;
}
/* 滚动槽 */
.type-list::-webkit-scrollbar-track {
  border-radius: 2px;
}
/* 滚动条滑块 */
.type-list::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.7);
}

</style>
